// extracted by mini-css-extract-plugin
export default {"btnContainer":"btnContainer___eRX6f","fileUploadBtn":"fileUploadBtn___PI8Jr","uploadedFileContainer":"uploadedFileContainer___VfGTc"};